export default {
  LOAD_STUDY_PROGRAM_CASE_LIST_START: 'LoadStudyProgramCaseListStart',
  LOAD_STUDY_PROGRAM_CASE_LIST_END: 'LoadStudyProgramCaseListEnd',
  TOGGLE_STUDY_PROGRAM_CASE_LIST_CONFIRM_DIALOG: 'ToggleStudyProgramCaseListConfirmDialog'
};